<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M11.5 20.5v-5h1v2h8v1h-8v2zm-8-2v-1h5v1zm4-4v-2h-4v-1h4v-2h1v5zm4-2v-1h9v1zm4-4v-5h1v2h4v1h-4v2zm-12-2v-1h9v1z"
      />
    </svg>
  </span>
</template>
